import axios from "axios";
import { SetLookUpData } from "../Reducers/LookUpSlice";
const apiUrl = process.env.REACT_APP_API_URL;
export function LookUpGetAll() {
  return async function LookUp(Dispatch) {
    try {
      const res = await axios.get(`${apiUrl}LookUp/GetAll`);
      Dispatch(SetLookUpData(res?.data?.data));
    } catch (e) {
      console.log(e);
    }
  };
}
